export default {
	type: 'object',
	properties: {
		recordId: { type: 'string' },
		email: { type: 'string' },
	},
	required: ['recordId'],
	additionalProperties: false,
}
